/* eslint-disable */
<template>
  <div class="users">
    <AdminNavigation ref="navigation" indexProps="9" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Users</h1></div>
        <div class="header-sub-title">A list of all the users of Red Health Online - clients, specialists and Red Health admin.</div>
      </div>
    </div>
    <div class="panel">
      <AdminUserMenu indexProps="0" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input style="max-width: 115px" class="mr-1" @input="search()" clearable placeholder="Phone" v-model="listParam.Mobile"/>
            <el-input style="max-width: 115px" class="mr-1" @input="search()" clearable placeholder="Email" v-model="listParam.EmailAddress"/>
            <el-input style="max-width: 115px" class="mr-1" @input="search()" clearable placeholder="UserName" v-model="listParam.UserName"/>
          </div>
        </div>
        <div class="table-responsive">
          <div>
            <div>
              <el-table @row-click="RowClick" ref="bookingTable" :default-sort="{prop: 'UserName', order: 'ascending'}" stripe @sort-change="sortParam" :data="allUsers" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    prop="id"
                    label="User ID"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="UserName"
                    sortable="custom"
                    label="User Name">
                  <template slot-scope="scope">
                    <span>{{decodeURIComponent(scope.row.name)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="RoleName"
                    label="Role"
                    sortable="custom"
                    width="180">
                  <template slot-scope="scope">
                    <span>{{decodeURIComponent(scope.row.typeName)}}</span>
                  </template>
                </el-table-column>

                <el-table-column
                    prop="LastLoggedInDate"
                    label="Last Logged In"
                    sortable="custom"
                    width="180">
                  <template slot-scope="row">
                    {{ formatDate(row.row.lastLoggedInDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss.ssssss") }}
                  </template>
                </el-table-column>
                <el-table-column
                    prop="UserStatus"
                    label="Can Login"
                    sortable="custom"
                    width="180">
                  <template slot-scope="row">
                    <input disabled type="checkbox" :checked="row.row.status" :value="row.row.status" />
                  </template>
                </el-table-column>
                <el-table-column
                    prop="EmailAddress"
                    label="Email"
                    sortable="custom"
                    width="200">
                  <template slot-scope="scope">
                    <span>{{decodeURIComponent(scope.row.email)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="Mobile"
                    label="Phone"
                    sortable="custom"
                    width="180">
                  <template slot-scope="scope">
                    <span>{{decodeURIComponent(scope.row.phone)}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))"
                     :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item"
                     @click="selectPage(item, 0)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminUserMenu from "@/components/AdminUserMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';

export default {
  name: "AdminUsers",
  components: {
    AdminNavigation,
    AdminUserMenu,
    Header,
  },
  data() {
    return {
      users: [],
      allUsers: [],
      totalCount: 0,
      limit: 10,
      pagination: utilities.initPagination(),
      listParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: 'UserName',
        ascOrDesc: 'ASC',
        UserName: null,
      },
      byName: false,
      byRole: false,
      byLastLoggedIn: false,
      byStatus: false,
      // searchTerm: '',
      searchByUsername: '',
      searchByEmail: '',
      searchByMobile: '',
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },

    search: debounce(function () {
      this.selectPage(1)
    }, 800),

    RowClick(row) {
      this.openUser(row?.id)
    },

    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },

    formatDate(dateToFormat, newFormat = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },
    openUser(id) {
      if(this.user.type == 6) this.$router.push({ name: 'admin-manage-user', query: { id: id } })
    },

    async loadData() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      const {users, count} = await utilities.getUsersNew(this.listParam)
      this.allUsers = users
      this.totalCount = count
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
  },
  async beforeMount() {

    if (!utilities.isAdmin(this.user.type)) {
      this.$router.go(-1)
      return false
    }
    await this.loadData()
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
